import React, { FunctionComponent, useContext, useMemo } from "react";
import styled from "styled-components";
import { Car } from "../../services/mobile";
import theme from "../theme";

const Wrapper = styled.div`
  color: ${theme.colors.blue};
  font-size: ${theme.fonts.big.fontSize};
  font-weight: ${theme.fonts.big.fontWeight};
  padding-bottom: 20px;
`;

interface Props {
  car: Car;
  suffix?: string;
}

const Price: FunctionComponent<Props> = ({ car, suffix }) => {
  const formattedPrice = car.price
    ? Intl.NumberFormat("nl-NL", {
        style: "currency",
        currency: "EUR",
        maximumFractionDigits: 0,
        minimumFractionDigits: 0,
      }).format(car.price)
    : null;

  return (
    <Wrapper>
      {formattedPrice}
      {suffix && suffix}
    </Wrapper>
  );
};

export default Price;
